export function getGETS(){
	const prmstr = window.location.search.substr(1);
	return prmstr != null && prmstr != "" ? transformGETsToObj(prmstr) : {};
}

function transformGETsToObj( prmstr ) {
	let params = {};
	const prmarr = prmstr.split("&");
	for ( let i = 0; i < prmarr.length; i++) {
		const tmparr = prmarr[i].split("=");
		params[tmparr[0]] = decodeURIComponent(tmparr[1]);
	}
	return params;
}
